
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/exchange",
      function () {
        return require("private-next-pages/section/exchange.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/exchange"])
      });
    }
  